"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var InvitePricingModal_1 = __importDefault(require("./InvitePricingModal"));
var ContactSupportForUsersModal_1 = require("../../Common/ContactSupportForUsersModal/ContactSupportForUsersModal");
var ErrorCodes_1 = require("@CommonFrontendBackend/ErrorCodes/ErrorCodes");
var event_tracker_types_1 = require("@qwilr/event-tracker-types");
var InviteUserService = (function () {
    function InviteUserService($http, apiBaseUrl, account, telemetry, invoke, rootDataStore, seatsService, modal, environment, serverTelemetry) {
        this.$http = $http;
        this.apiBaseUrl = apiBaseUrl;
        this.account = account;
        this.telemetry = telemetry;
        this.invoke = invoke;
        this.rootDataStore = rootDataStore;
        this.seatsService = seatsService;
        this.modal = modal;
        this.environment = environment;
        this.serverTelemetry = serverTelemetry;
    }
    InviteUserService.prototype.inviteWithModal = function (emails, newInviteCount, role, team) {
        return __awaiter(this, void 0, void 0, function () {
            var supportModal, invitePricingModal, isTrial, ctaClicked;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(newInviteCount == 0)) return [3, 2];
                        return [4, this.invite(emails, role, team)];
                    case 1:
                        _a.sent();
                        return [3, 7];
                    case 2:
                        if (!(this.seatsService.remainingSeats() <= 0 && !this.seatsService.canModifySeats())) return [3, 4];
                        supportModal = new ContactSupportForUsersModal_1.ContactSupportForUsersModal(this.modal);
                        return [4, supportModal.showModal(newInviteCount)];
                    case 3:
                        _a.sent();
                        return [3, 7];
                    case 4:
                        invitePricingModal = this.invoke(InvitePricingModal_1.default);
                        isTrial = this.account.plan.displayName === "Trial";
                        return [4, invitePricingModal(newInviteCount, isTrial)];
                    case 5:
                        ctaClicked = _a.sent();
                        if (!ctaClicked) return [3, 7];
                        return [4, this.invite(emails, role, team)];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7: return [2];
                }
            });
        });
    };
    InviteUserService.prototype.invite = function (emails, role, team) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var _e, $http, apiBaseUrl, account, rootDataStore, serverTelemetry, userInvites, response, _f, additionalSeats, pendingInvitations, currentSeatCount, occupiedSeats, fireCustomerSuccessNotification, userInvites_1, userInvites_1_1, invite, e_1;
            var e_2, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        _e = this, $http = _e.$http, apiBaseUrl = _e.apiBaseUrl, account = _e.account, rootDataStore = _e.rootDataStore, serverTelemetry = _e.serverTelemetry;
                        userInvites = emails.map(function (email) {
                            if (!!team) {
                                return {
                                    email: email,
                                    role: role,
                                    team: team,
                                };
                            }
                            else {
                                return {
                                    email: email,
                                    role: role,
                                };
                            }
                        });
                        _h.label = 1;
                    case 1:
                        _h.trys.push([1, 3, , 4]);
                        return [4, $http.post("".concat(apiBaseUrl, "/accounts/").concat(account._id, "/invites/invite-with-seats"), {
                                invites: userInvites,
                            })];
                    case 2:
                        response = _h.sent();
                        _f = response.data.message, additionalSeats = _f.additionalSeats, pendingInvitations = _f.pendingInvitations;
                        account.pendingInvitations = pendingInvitations;
                        account.additionalSeats = additionalSeats;
                        rootDataStore.getAccountDataStore().getPendingUsersDataStore().refreshPendingUsers();
                        currentSeatCount = account.plan.seats.included + account.additionalSeats;
                        occupiedSeats = ((_a = account.users) === null || _a === void 0 ? void 0 : _a.length) + account.pendingInvitations.length;
                        fireCustomerSuccessNotification = account.plan.displayName === "Enterprise" && occupiedSeats >= 10 && currentSeatCount < 10;
                        if (this.environment === "production" && fireCustomerSuccessNotification) {
                            if (typeof Intercom !== "undefined" && Intercom) {
                                Intercom("trackEvent", "Account added 10th seat");
                            }
                        }
                        try {
                            for (userInvites_1 = __values(userInvites), userInvites_1_1 = userInvites_1.next(); !userInvites_1_1.done; userInvites_1_1 = userInvites_1.next()) {
                                invite = userInvites_1_1.value;
                                serverTelemetry.sendUserInvitedTelemetry({
                                    eventOrigin: event_tracker_types_1.EventOrigin.QwilrTeamSettings,
                                    eventProperties: {
                                        planPendingInvites: account.pendingInvitations.length,
                                        userInviteeType: invite.role,
                                    },
                                });
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (userInvites_1_1 && !userInvites_1_1.done && (_g = userInvites_1.return)) _g.call(userInvites_1);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        return [3, 4];
                    case 3:
                        e_1 = _h.sent();
                        if (((_d = (_c = (_b = e_1.data) === null || _b === void 0 ? void 0 : _b.error) === null || _c === void 0 ? void 0 : _c.additionalInfo) === null || _d === void 0 ? void 0 : _d.errorCode) === ErrorCodes_1.ServerErrorCode.EmailAlreadyExists) {
                            this.telemetry.trackOnly("Invite User Email Already Exists", {}, { blockIntercom: true });
                        }
                        throw e_1;
                    case 4: return [2];
                }
            });
        });
    };
    return InviteUserService;
}());
exports.default = InviteUserService;
